import React from 'react';
import {extend} from '../zviz3/functions';
import {ConnectState} from '../zviz3/Connect';

import woning from '../images/woning.svg';
import muren from '../images/muren.svg';
import dak from '../images/dak.svg';
import vloer from '../images/vloer.svg';
import glas from '../images/glas.svg';
import extra from '../images/extra.svg';
import advies from '../images/advies.svg';
import subsidie from '../images/subsidie.svg';

const images = {
    woning: woning,
    muren: muren,
    dak: dak,
    vloer: vloer,
    glas: glas,
    extra: extra,
    advies: advies,
    subsidie: subsidie
};

const styleIcon = {
    display: 'inline-block',
    verticalAlign: 'middle'
};

export default ConnectState(function Icon(props){
    
    const f = props.renderSize==='small'? 0.7: 1;

    const width = f*props.width || f*80;
    const style = extend(
            extend({marginRight: (f*20) + 'px'}, styleIcon), 
            props.style || {});
    const image = images[props.type];

    return <img src={image} alt={props.type} width={width+'px'} style={style} />
}, 'renderSize');


// WEBPACK FOOTER //
// ./src/elements/icon.js